import { Badge, type BadgeProps } from "@/components/ui/badge";

/** Run / step status → display label. The server emits these snake_case codes
 *  on the `status` field of agent runs and steps. */
const STATUS_LABELS: Record<string, string> = {
  pending: "Pending",
  planning: "Planning",
  awaiting_approval: "Awaiting approval",
  awaiting_human: "Awaiting you",
  running: "Running",
  paused: "Paused",
  done: "Done",
  skipped: "Skipped",
  failed: "Failed",
  cancelled: "Cancelled",
};

const STATUS_VARIANTS: Record<string, BadgeProps["variant"]> = {
  pending: "warning",
  planning: "primary",
  awaiting_approval: "warning",
  awaiting_human: "warning",
  running: "primary",
  paused: "warning",
  done: "success",
  skipped: "default",
  failed: "destructive",
  cancelled: "default",
};

/** Status badge for an agent run or step. Falls back to the raw code +
 *  neutral variant for any status not in the table, so a new server status
 *  never renders blank. */
export function RunStatusBadge({ status }: { status: string }) {
  return (
    <Badge variant={STATUS_VARIANTS[status] ?? "default"}>
      {STATUS_LABELS[status] ?? status}
    </Badge>
  );
}
